<template>
    <div class="bg-white p-8 md:p-12 font-sans">
        <div class="p-8 sm:p-12 max-w-7xl mx-auto">
            <section class="grid grid-cols-1 lg:grid-cols-2 gap-8 relative">
                
                <div class="flex flex-col space-y-6">
                    <h2 class="text-4xl lg:text-5xl font-bold text-orange-500">OverX: Implementação e Resultados</h2>
                    <div class="text-black space-y-4 leading-relaxed">
                        <p>A OverX foi implementada para otimizar a qualificação de leads e a gestão de oportunidades. Com a implementação da plataforma, conseguimos organizar a base de dados de maneira centralizada, permitindo envios mais assertivos e direcionados para o time de vendas.</p>
                        <p>Além disso, a plataforma da OverX proporcionou análises mais precisas sobre os leads qualificados, resultando na melhoria do fluxo de trabalho e maior controle sobre as métricas de desempenho.</p>
                        <p>Com foco na qualificação da base de leads e direcionamento para oportunidades de maior valor, a OverX ajudou a aumentar a eficiência do time de vendas e reduzir o desperdício de esforços em leads não qualificados.</p>
                        <p>Nos últimos 11 meses, a OverX gerou um aumento de <span class="text-orange-500 font-semibold">31,3%</span> na base total de leads e um aumento de <span class="text-orange-500 font-semibold">94%</span> nos leads engajados. Esses resultados refletem a eficiência da plataforma e a melhoria contínua nas estratégias de qualificação e engajamento.</p>
                    </div>
                </div>

                <div class="flex flex-col space-y-8 mt-8 lg:mt-0">
                    <div class="hidden lg:block absolute top-0 left-1/2 -ml-4 z-10">
                        <div class="absolute -top-4">
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 0V32" stroke="#D1D5DB" stroke-width="1"/><path d="M0 16H32" stroke="#D1D5DB" stroke-width="1"/></svg>
                        </div>
                        <div class="absolute top-[13.5rem]">
                           <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 0V32" stroke="#D1D5DB" stroke-width="1"/><path d="M0 16H32" stroke="#D1D5DB" stroke-width="1"/></svg>
                        </div>
                        <div class="absolute top-[26rem]">
                           <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 0V32" stroke="#D1D5DB" stroke-width="1"/><path d="M0 16H32" stroke="#D1D5DB" stroke-width="1"/></svg>
                        </div>
                    </div>
                    
                    <div class="bg-orange-500 text-white p-8 shape-custom">
                        <p class="text-8xl font-bold">138%</p>
                        <p class="mt-2 text-lg">Aumento de 138% em leads engajados</p>
                    </div>

                    <div class="h-48 flex items-center justify-center rounded-lg text-gray-500">
                        <img src="@/assets/fundo.png" alt="Exemplo do componente OverX"
                          class="rounded-lg shadow-2xl shadow-orange-500/10">
                    </div>

                    <br/>
                    <div class="bg-orange-500 text-white p-8 shape-custom">
                        <p class="text-8xl font-bold">67%</p>
                        <p class="mt-2 text-lg">Diminuição em 67% de leads sem definição de marca de interesse</p>
                    </div>
                </div>
            </section>

            <br/>
            <br/>
            <br/>
            <br/>

            <section class="mt-8">
                <div class="h-80 flex items-center justify-centerrounded-lg text-gray-500">
                    <img src="@/assets/img2.png" alt="Exemplo do componente OverX"
                      class="rounded-lg shadow-2xl shadow-orange-500/10">
                </div>
            </section>
        </div>
    </div>
</template>

<script setup>
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;700;900&display=swap');
.font-sans {
    font-family: 'Sora', sans-serif;
}

.shape-custom {
  border-top-left-radius: 1.25rem; 
  border-top-right-radius: 1.25rem; 
  border-bottom-right-radius: 1.25rem;
  border-bottom-left-radius: 0.25rem;
}
</style>